import styled from 'styled-components';

export const AddGradientContainer = styled.div`
width:100vw;
min-height:100vh;
background:#1D1E22;
`;

export const Container = styled.div`
width:100%;
padding-top:70px;
display:grid;
grid-template-columns:80% auto;
@media screen and (max-width: 1200px){
        grid-template-columns: 70% 30%;
    }

    @media screen and (max-width: 1000px){
        grid-template-columns: 70% 30%;
    }
    @media screen and (max-width: 550px){
        padding-top:60px;

    }
`;


export const GradientBox = styled.div`
    height:80px;
    width:100%;
    background-image: linear-gradient(${(props) => props.direction},
    ${(props) => props.start}
    ,${(props) => props.end});
    cursor:pointer;
    border-radius:10px;

`;
export const GradientChips = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    width:100%;
    height:150px;
    background-image: linear-gradient(${(props) => props.direction},${(props) => props.start},${(props) => props.end});
    
    & div{
        display:none;
    }

    &: hover div{
        display:block;
    }
`;

export const Gradient = styled.div`
 display:grid;
 grid-template-columns:1fr 1fr 1fr;
 grid-gap:10px;
 padding:10px;

 @media screen and (max-width: 1200px){
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 1000px){
        grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 750px){
      grid-template-columns: 1fr;
      grid-gap: 20px;
    }

    @media screen and (max-width: 480px){
        grid-template-columns: 1fr;

    }

`;

export const FormColumn = styled.div`
display:flex;
justify-content:center;
padding:10px;
background:#111214;
position:fixed;
height:100%;
right:0;
`;

export const Form = styled.form`
    display:flex;
    flex-direction:column;

    Label{
        font-size:15px;
        font-family:'Open Sans';
        color:white;
        margin-left:5px;
    }

input[type='text']{
    width:250px;
    height:30px;
    border-radius:5px;
    border:0;
    margin:5px;
    margin-bottom:15px;
    padding-left:10px;
}
`;

export const Button = styled.button`
width:260px;
height:30px;
border-radius:5px;
background:${(props)=>props.color};
border:0;
color:white;
margin-top:12px;
margin-left:5px;

&:hover{
    background:${(props)=>props.hover};
}
`;

export const Grid = styled.div`
    display:grid;
    grid-template-columns:1fr 1fr;
    grid-gap:10px;
    text-align:center;
    font-family:'Open Sans';
    color:white;
`;

export const Edit = styled.button`
    background:${(props)=>props.color};
    padding:5px 20px;
    color:white;
    border:0;
    cursor: pointer;
    margin:5px;
    border-radius:5px;

    &:hover{
        background:${(props)=>props.hover};
    }
`;